{
  "colorFormat": "Format koloru",
  "hex": "Szesnastkowy",
  "hsb": "HSB",
  "hsl": "HSL",
  "rgb": "RGB"
}
